// 自动获取焦点
export default {
  /**
   * 当被绑定的元素插入到 DOM 中时
   * 
   * @param el 元素
   */
  inserted: function (el, binding) {
    // 聚焦元素
    const {
      title,
      keywords,
      description
    } = binding.value
    if (document.querySelector('meta[name=keywords]')) {
      document.querySelector('meta[name=keywords]').remove()
    }
    if (document.querySelector('meta[name=description]')) {
      document.querySelector('meta[name=description]').remove()
    }
    if (title && title != '') {
      //设置title
      document.title = title
    }
    if (keywords && keywords != '') {
      //设置keywords
      let head = document.getElementsByTagName('head');
      let meta = document.createElement('meta');
      meta.setAttribute("name", "keywords");
      meta.content = keywords;
      head[0].appendChild(meta)
    }
    if (description && description != '') {
      //设置description
      let head = document.getElementsByTagName('head');
      let meta = document.createElement('meta');
      meta.setAttribute("name", "description");
      meta.content = description;
      head[0].appendChild(meta)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/directives/meta.js